import { useEffect } from 'react'

/**
 * Tallyフォーム送信完了時にGTMコンバージョンイベントを発火するフック
 * ref: https://tally.so/help/developer-resources#4ceb770c20d84d34b1e0eaf8d62a7735
 */
export const useTallyFormSubmit = () => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!event || event.origin !== 'https://tally.so') {
        return
      }

      if (!event.data) {
        return
      }

      // event.dataはJSON文字列でTallyから送られてきたイベントデータが入っている
      // JSONをparseせずにTallyのフォーム投稿イベントかどうかをチェック
      if (typeof event.data !== 'string' || event.data.indexOf('Tally.FormSubmitted') === -1) {
        return
      }

      // GiftmallとGoogle Adsとの連携はGTMを経由するためDataLayerを使用
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'gtm-tally-corporate-contact-conversion-event-trigger',
      })
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [])
}
